import {
  getExportForwardedSifarishUser,
  getExportReportedSifarishUser,
  getExportSavedSifarishUser,
  getUserSifarishDetails,
  acceptBusinessProfileRequest,
  rejectBusinessProfileRequest,
} from "_services";
import { ButtonHeading } from "components";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Images } from "constants";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { utils } from "helper";
import { AddSifarishModal } from "modals";

const SifarishDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { listData, currentIndexx } = location.state || {};
  const [activeIndex, setActiveIndex] = useState(currentIndexx ?? 0);
  const [sifarishDetails, setSifarishDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const [userData, setUserData] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [sifarishToEdit, setSifarishToEdit] = useState(null);
  const [allSifarishToEdit, setAllSifarishToEdit] = useState([]);
  const [sifarishInd, setSifarishInd] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    }
  }, []);

  const userId = userData?._id;
  const sifarishId = searchParams.get("sifarishId");

  useEffect(() => {
    if (!userId) return;
    if (listData && listData.length > 0) return;

    if (sifarishId) {
      fetchSifarishDetails(sifarishId);
    }
  }, [userId, sifarishId]);

  useEffect(() => {
    if (!userId) return;
    if (!listData || !listData[activeIndex]) return;

    const newSifarishId = listData[activeIndex]._id;

    navigate(
      `/sifarish/getSifarishes?userId=${userId}&sifarishId=${newSifarishId}`,
      {
        replace: true,
        state: { listData, currentIndexx: activeIndex },
      }
    );

    fetchSifarishDetails(newSifarishId);
  }, [activeIndex, userId]);

  const fetchSifarishDetails = async (sifarishIdParam) => {
    setLoading(true);
    setError(null);
    const controller = new AbortController();
    const signal = controller.signal;

    try {
      // const payload = { userId, sifarishId };
      const payload = {
        userId,
        sifarishId: sifarishIdParam || sifarishId,
      };
      const res = await getUserSifarishDetails(payload, { signal });

      if (res?.data?.sifarish) {
        setSifarishDetails(res.data.sifarish);
      } else {
        throw new Error(res?.responseMessage || "No data found");
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        setError(error.message || "Something went wrong");
        toast.error(error.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
  };

  const exportSavedSifarishToCSV = async () => {
    try {
      const payload = {
        userId: userId,
        sifarishId: sifarishId,
        page: 1,
        limit: -1,
      };

      const res = await getExportSavedSifarishUser(payload);

      if (!res || !res.data?.users || res.data.users.length === 0) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.users;

      const csvHeaders = [
        "Serial No",
        "User",
        "Bird Name",
        "Phone No.",
        "Sifarish Score",
        "Recommended Status",
        "Generation",
        "Location",
      ];

      const csvRows = fullData.map((user, index) => [
        index + 1,
        `"${user?.fromUser?.firstName || "-"} ${user?.fromUser?.lastName || "-"
        }"`,
        user?.fromUser?.birdId?.title || "-",
        `"${user?.fromUser?.countryCode || "-"} ${user?.fromUser?.phoneNumber || "-"
        }"`,
        user?.fromUser?.sifarishPoints || "-",
        user?.isRecommended === true ? "Recommended" : "Not Recommended",
        user?.fromUser?.generationId?.title || "-",
        `"${user?.fromUser?.city || "-"}, ${user?.fromUser?.state || "-"}, ${user?.fromUser?.country || "-"
        }"`,
      ]);

      const csvContent =
        "data:text/csv;charset=utf-8," +
        [csvHeaders.join(","), ...csvRows.map((row) => row.join(","))].join(
          "\n"
        );

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.href = encodedUri;
      const epochTime = Date.now();
      link.download = `Saved_Sifarish_User_${epochTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const exportForwardSifarishToCSV = async () => {
    try {
      const payload = {
        userId: userId,
        sifarishId: sifarishId,
        page: 1,
        limit: -1,
      };

      const res = await getExportForwardedSifarishUser(payload);

      if (!res || !res.data?.users || res.data.users.length === 0) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.users;

      const csvHeaders = [
        "Serial No",
        "User",
        "Bird Name",
        "Phone No.",
        "Sifarish Score",
        "Generation",
        "Location",
      ];

      const csvRows = fullData.map((user, index) => [
        index + 1,
        `"${user?.fromUserId?.firstName || "-"} ${user?.fromUserId?.lastName || "-"
        }"`,
        user?.fromUserId?.birdId?.title || "-",
        `"${user?.fromUserId?.countryCode || "-"} ${user?.fromUserId?.phoneNumber || "-"
        }"`,
        user?.fromUserId?.sifarishPoints || "-",
        user?.fromUserId?.generationId?.title || "-",
        `"${user?.fromUserId?.city || "-"}, ${user?.fromUserId?.state || "-"
        }, ${user?.fromUserId?.country || "-"}"`,
      ]);

      const csvContent =
        "data:text/csv;charset=utf-8," +
        [csvHeaders.join(","), ...csvRows.map((row) => row.join(","))].join(
          "\n"
        );

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.href = encodedUri;
      const epochTime = Date.now();
      link.download = `Forwarded_Sifarish_User_${epochTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const exportReportedSifarishToCSV = async () => {
    try {
      const payload = {
        userId: userId,
        sifarishId: sifarishId,
        page: 1,
        limit: -1,
      };

      const res = await getExportReportedSifarishUser(payload);

      if (!res || !res.data?.users || res.data.users.length === 0) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.users;

      const csvHeaders = [
        "Serial No",
        "User",
        "Bird Name",
        "Phone No.",
        "Sifarish Score",
        "Generation",
        "Location",
        "Reported Reason",
      ];

      const csvRows = fullData.map((user, index) => [
        index + 1,
        `"${user?.fromUserId?.firstName || "-"} ${user?.fromUserId?.lastName || "-"
        }"`,
        user?.fromUserId?.birdId?.title || "-",
        `"${user?.fromUserId?.countryCode || "-"} ${user?.fromUserId?.phoneNumber || "-"
        }"`,
        user?.fromUserId?.sifarishPoints || "-",
        user?.fromUserId?.generationId?.title || "-",
        `"${user?.fromUserId?.city || "-"}, ${user?.fromUserId?.state || "-"
        }, ${user?.fromUserId?.country || "-"}"`,
        `"${user?.reasonId?.title || "-"}"`,
      ]);

      const csvContent =
        "data:text/csv;charset=utf-8," +
        [csvHeaders.join(","), ...csvRows.map((row) => row.join(","))].join(
          "\n"
        );

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.href = encodedUri;
      const epochTime = Date.now();
      link.download = `Reported_Sifarish_User_${epochTime}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const handleBackButton = () => {
    navigate(-1);
  };

  const isBusinessProfileRequest =
    sifarishDetails?.isActive === false &&
    sifarishDetails?.isDeleted === false &&
    sifarishDetails?.isRegisteredByBusiness === true;

  const handleApprove = async () => {
    if (
      !window.confirm(
        "Are you sure you want to approve this business request? It will be marked as active."
      )
    )
      return;
    if (!userId || !sifarishId) return;
    setActionLoading(true);
    try {
      const res = await acceptBusinessProfileRequest({
        userId,
        sifarishId,
      });
      if (res?.status === 1) {
        toast.success(res?.message || "Approved.");
        fetchSifarishDetails(sifarishId);
      } else {
        toast.error(res?.message || "Failed to approve.");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    } finally {
      setActionLoading(false);
    }
  };

  const handleReject = async () => {
    if (
      !window.confirm(
        "Are you sure you want to reject this business request? It will be marked as deleted."
      )
    )
      return;
    if (!userId || !sifarishId) return;
    setActionLoading(true);
    try {
      const res = await rejectBusinessProfileRequest({
        userId,
        sifarishId,
      });
      if (res?.status === 1) {
        toast.success(res?.message || "Rejected.");
        navigate("/business_profile_requests");
      } else {
        toast.error(res?.message || "Failed to reject.");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <>
      <ButtonHeading
        title="Sifarish Details"
        isShow={{
          isBackButton: true,
        }}
        handleBackButton={() => handleBackButton()}
        extraRightContent={
          isBusinessProfileRequest ? (
            <>
              <div className="_rSideBtn">
                <button
                  className="_addComm_btn"
                  style={{ background: "#198754" }}
                  onClick={handleApprove}
                  disabled={actionLoading}
                >
                  {actionLoading ? "..." : "Approve"}
                </button>
              </div>
              <div className="_rSideBtn">
                <button
                  className="_addComm_btn"
                  style={{ background: "var(--reject-red)" }}
                  onClick={handleReject}
                  disabled={actionLoading}
                >
                  Reject
                </button>
              </div>
            </>
          ) : null
        }
      />

      <div className="d-flex justify-content-between px-3 mt-3">
        <button
          disabled={activeIndex === 0}
          className="__birdTag"
          onClick={() => setActiveIndex((prev) => prev - 1)}
        >
          ⬅ Previous
        </button>

        <button
          disabled={activeIndex === listData.length - 1}
          className="__birdTag"
          onClick={() => setActiveIndex((prev) => prev + 1)}
        >
          Next ➜
        </button>
      </div>

      <div>
        {loading ? (
          <p>Loading Sifarish Details...</p>
        ) : error ? (
          <p className="text-red-500">Error: {error}</p>
        ) : sifarishDetails ? (
          <>
            <div className="py-4">
              <div className=" __sifarisD_head  mb-3 ">
                <div className="__sifDetail_bxs" style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                  {sifarishDetails?.logoUrl && (
                    <img
                      src={sifarishDetails.logoUrl}
                      alt="Logo"
                      width={50}
                      height={50}
                      style={{
                        borderRadius: 10,
                        objectFit: "cover",
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                      onClick={() => {
                        setCurrentIndex(0);
                        setLightboxOpen(true);
                      }}
                    />
                  )}
                  <div>
                    <h4>Title: {sifarishDetails?.title || "No Title"}</h4>
                    <p>Description: {sifarishDetails?.description || ""}</p>
                  </div>
                </div>

                <div className="__rSide_btn">
                  <button
                    className="__birdTag "
                    onClick={() => exportSavedSifarishToCSV()}
                  >
                    Export saved sifarish users
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => exportForwardSifarishToCSV()}
                  >
                    Export forwarded sifarish users
                  </button>
                  <button
                    className="__birdTag "
                    onClick={() => exportReportedSifarishToCSV()}
                  >
                    Export reported sifarish users
                  </button>

                  <button
                    className="__birdTag"
                    onClick={() => {
                      setSifarishToEdit(sifarishDetails);
                      setAllSifarishToEdit(listData || []);
                      setSifarishInd(activeIndex);
                      setIsOpen(true);
                    }}
                  >
                    Edit Sifarish
                  </button>
                </div>
              </div>

              {/* Media URLs - only media */}
              {sifarishDetails?.mediaUrls?.length > 0 ? (
                <div className="mb-4">
                  <h6 className="mb-2">Media</h6>
                  {sifarishDetails.mediaUrls.length === 1 ? (
                    <img
                      src={
                        sifarishDetails.mediaUrls[0]?.url ||
                        "https://via.placeholder.com/400x300"
                      }
                      alt=""
                      width={400}
                      height={300}
                      className="_slidImgOne"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        const logoOffset = sifarishDetails?.logoUrl ? 1 : 0;
                        setCurrentIndex(logoOffset + 0);
                        setLightboxOpen(true);
                      }}
                    />
                  ) : (
                    <Slider {...sliderSettings} className="__anvSlickSlider">
                      {sifarishDetails.mediaUrls.map((item, index) => (
                        <div key={index}>
                          <img
                            onClick={() => {
                              const logoOffset = sifarishDetails?.logoUrl ? 1 : 0;
                              setCurrentIndex(logoOffset + index);
                              setLightboxOpen(true);
                            }}
                            src={
                              item?.url || "https://via.placeholder.com/400x300"
                            }
                            alt=""
                            width={400}
                            height={300}
                            className="_slidImg"
                          />
                        </div>
                      ))}
                    </Slider>
                  )}
                </div>
              ) : (
                !sifarishDetails?.logoUrl &&
                !sifarishDetails?.businessProofUrl && (
                  <p className="text-center">No Media Available</p>
                )
              )}
            </div>

            <div className="px-4 pb-4">
              <div className="__userView ">
                <div className="mb-2">
                  <img
                    src={
                      sifarishDetails?.createdByUserId?.userProfileImageUrl ||
                      Images.USERLIMG
                    }
                    alt="user Img"
                    style={{ borderRadius: "50%" }}
                    width={60}
                    height={60}
                  />
                </div>

                <div>
                  <h4>
                    {sifarishDetails?.createdByUserId?.firstName}{" "}
                    {sifarishDetails?.createdByUserId?.lastName}
                  </h4>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "6px" }}
                >
                  <p>{sifarishDetails?.createdByUserId?.phoneNumber} </p>
                </div>

                <div>
                  <p>
                    <b>Category: </b>
                    {sifarishDetails?.categoryId?.title}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Subcategory: </b>

                    {sifarishDetails?.categoryId?.subCategories?.length > 0
                      ? sifarishDetails.categoryId.subCategories
                        .filter(
                          (sub) => sub._id === sifarishDetails.subCategoryId
                        )
                        .map((sub) => <span key={sub._id}>{sub.title}</span>)
                      : "No Subcategory Available"}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Links: </b>
                    {sifarishDetails?.links?.length > 0
                      ? sifarishDetails.links.map((url, index) => (
                        <Link key={url} to={url.url} target="_blank">
                          {url.url}
                          {index !== sifarishDetails.links.length - 1
                            ? ", "
                            : ""}
                        </Link>
                      ))
                      : "No Links Available"}
                  </p>
                </div>

                <div className="__staTics">
                  <h5>Statistics</h5>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>
                      Total Forwarded <IoMdInformationCircleOutline />
                    </h6>
                    <p>{sifarishDetails?.totalForwarded}</p>
                  </div>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>
                      Total Recomended Reviews
                      <IoMdInformationCircleOutline />
                    </h6>
                    <p>{sifarishDetails?.totalRecommendedReviews}</p>
                  </div>

                  <div style={{ flex: "0 0 33.33%" }}>
                    <h6>
                      Total Reviews <IoMdInformationCircleOutline />
                    </h6>
                    <p>{sifarishDetails?.totalReviews}</p>
                  </div>
                </div>
                <div>
                  <p>
                    <b>Created Date: </b>
                    {sifarishDetails?.createdAt
                      ? utils?.formatDateToDDMMYYYY(sifarishDetails?.createdAt)
                      : ""}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Contact Name: </b>
                    {sifarishDetails?.contactName}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Contact Email: </b>
                    {sifarishDetails?.email}
                  </p>
                </div>

                <div>
                  <p>
                    <b>Contact Number: </b>
                    {sifarishDetails?.phoneNumber}
                  </p>
                </div>

                {(sifarishDetails?.contactPersonRole ||
                  (sifarishDetails?.offering?.length > 0)) && (
                    <div className="mt-3">
                      <h6 className="mb-2">Business details</h6>
                      {sifarishDetails?.contactPersonRole && (
                        <div>
                          <p>
                            <b>Contact person role: </b>
                            {sifarishDetails.contactPersonRole}
                          </p>
                        </div>
                      )}
                      {sifarishDetails?.offering?.length > 0 && (
                        <div>
                          <p>
                            <b>Offering: </b>
                            {sifarishDetails.offering.join(", ")}
                          </p>
                        </div>
                      )}
                    </div>
                  )}
              </div>
            </div>

            {/* Business proof - at last */}
            {sifarishDetails?.businessProofUrl && (
              <div className="px-4 pb-4">
                <h6 className="mb-2">Business proof</h6>
                <img
                  src={sifarishDetails.businessProofUrl}
                  alt="Business proof"
                  width={200}
                  height={200}
                  className="_slidImgOne"
                  style={{ cursor: "pointer", objectFit: "contain" }}
                  onClick={() => {
                    const logoOffset = sifarishDetails?.logoUrl ? 1 : 0;
                    const mediaLen = sifarishDetails?.mediaUrls?.length || 0;
                    setCurrentIndex(logoOffset + mediaLen);
                    setLightboxOpen(true);
                  }}
                />
              </div>
            )}

            {lightboxOpen && (
              <div
                className="lightbox-overlay"
                onClick={() => setLightboxOpen(false)}
                onKeyDown={(e) => {
                  if (e.key === "Escape") setLightboxOpen(false);
                  if (e.key === "ArrowLeft") {
                    setCurrentIndex((prev) => Math.max(prev - 1, 0));
                  }
                  if (e.key === "ArrowRight") {
                    const allMedia = [
                      ...(sifarishDetails?.logoUrl
                        ? [{ url: sifarishDetails.logoUrl }]
                        : []),
                      ...(sifarishDetails?.mediaUrls || []),
                      ...(sifarishDetails?.businessProofUrl
                        ? [{ url: sifarishDetails.businessProofUrl }]
                        : []),
                    ];
                    setCurrentIndex((prev) =>
                      Math.min(prev + 1, allMedia.length - 1)
                    );
                  }
                }}
                tabIndex={0}
              >
                <div
                  className="lightbox-container"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="lightbox-close"
                    onClick={() => setLightboxOpen(false)}
                  >
                    ✕
                  </button>

                  <Slider {...sliderSettings} initialSlide={currentIndex}>
                    {[
                      ...(sifarishDetails?.logoUrl
                        ? [{ url: sifarishDetails.logoUrl }]
                        : []),
                      ...(sifarishDetails?.mediaUrls || []),
                      ...(sifarishDetails?.businessProofUrl
                        ? [{ url: sifarishDetails.businessProofUrl }]
                        : []),
                    ].map((item, index) => (
                      <div key={index} className="">
                        <img
                          src={
                            item?.url || "https://via.placeholder.com/800x600"
                          }
                          alt=""
                          className="lightbox-image"
                        />
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            )}
          </>
        ) : (
          <p>No Sifarish details available.</p>
        )}
      </div>

      {isOpen && (
        <AddSifarishModal
          isOpen={isOpen}
          closeModal={() => setIsOpen(false)}
          modalMainClass="_dashCommon_Modal _lgModal"
          modalTitle={sifarishToEdit ? "Edit Sifarish" : "Add Sifarish"}
          footerPart={true}
          submitTitle={sifarishToEdit ? "Update Sifarish" : "Add Sifarish"}
          setFilter={{}}
          filter={{}}
          userData={userData}
          onSuccess={() => fetchSifarishDetails(sifarishId)}
          sifarishToEdit={sifarishToEdit}
          sifarishArrayToEdit={{ allSifarishToEdit }}
          sifarishInd={sifarishInd}
        />
      )}
    </>
  );
};

export default SifarishDetail;
